import React from "react"
import { Link } from "gatsby"

import { rhythm, scale } from "../utils/typography"
import logo from "../../content/assets/the_viable_product.png"

const Layout = ({ location, title, children }) => {
  const rootPath = `${__PATH_PREFIX__}/`
  let header

  if (location.pathname === rootPath) {
    header = (
      <div>
      <h1
        style={{
          ...scale(1.2),
          marginBottom: rhythm(1.5),
          marginTop: 0,
          borderBottom: `1px solid lightgrey`
        }}
      >
        <Link
          style={{
            boxShadow: `none`,
            textDecoration: `none`,
            color: `inherit`,
          }}
          to={`/`}
        >
          <img src={logo} width="300px" alt="The Viable Product"/>
        </Link>
      </h1>
      </div>
    )
  } else {
    header = (
      <h3
        style={{
          fontFamily: `Montserrat, sans-serif`,
          marginTop: 0,
          borderBottom: `1px solid lightgrey`,
          cursor: `pointer`
        }}
      >
        <Link
          style={{
            boxShadow: `none`,
            textDecoration: `none`,
            color: `inherit`,
          }}
          to={`/`}
        >
          <img src={logo} width="200px" alt="The Viable Product"/>
        </Link>
      </h3>
    )
  }
  return (
    <div
      style={{
        marginLeft: `auto`,
        marginRight: `auto`,
        maxWidth: rhythm(24),
        padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
      }}
    >
      <header>{header}</header>
      <main>{children}</main>
      <footer
        style={{
          paddingTop: `20px`,
          borderTop: `1px solid lightgrey`
        }}
      >
        © {new Date().getFullYear()}
        {` `}
        The Viable Product
      </footer>
    </div>
  )
}

export default Layout
